import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/customer-route-plans', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/customer-route-plans', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/customer-route-plans/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

// export const destroy = id => {
//   return httpClient
//     .delete(`/api/v1/customer-route-plans/${id}`)
//     .then(response => Promise.resolve(response.data))
//     .catch(error => Promise.reject(error.response.data))
// }

export const user = (Options = {}) => {
  return httpClient
    .get('/api/v1/customer-route-plans/users', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const customer = (Options = {}) => {
  return httpClient
    .get('/api/v1/customer-route-plans/customers', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, store, update, user, customer }